import { render } from "./PrintROO.vue?vue&type=template&id=51353e10"
import script from "./PrintROO.vue?vue&type=script&lang=js"
export * from "./PrintROO.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__